/** @format */

import { useTranslation } from 'react-i18next';
import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import CustomButton from 'components/CustomButton';
import { Link } from 'react-router-dom';

import './styles.scss';

export default function BrokerHidden(props) {
  const { t } = useTranslation();

  const ProfileNotPublic = () => {
    return (
      <Container
        fluid
        className='content-wrapper broker-profile-not-public-container'>
        <div className='broker-profile-not-public-actions'>
          <h2>
            {t('lang_common:broker_profile:profile_not_public:heading:text')}
          </h2>
          <div className='broker-profile-not-public-button-wrapper'>
            <Link to='/'>
              <CustomButton
                text={t(
                  'lang_common:broker_profile:profile_not_public:button:text'
                )}
              />
            </Link>
          </div>
        </div>
        <div className='image-broker-profile-not-public' />
      </Container>
    );
  };

  return (
    <>
      <div className='main-container'>
        <Header {...props} t={t} />
        <div className='broker-hidden-container'>
          <ProfileNotPublic />
        </div>

        <Footer {...props} t={t} />
      </div>
    </>
  );
}
